import { tempoApi } from '@/lib/api/tempoApi';
import type { CreateItemStatus, ItemStatus, UpdateItemStatus } from '@/lib/api/types/itemStatus';

export const getItemStatusById = async (itemStatusId: number) =>
  await tempoApi().get(`api/v1/item-store/item-statuses/${itemStatusId}`).json<ItemStatus>();

export const getItemStatuses = async () =>
  await tempoApi().get('api/v1/item-store/item-statuses').json<ItemStatus[]>();

export const createItemStatus = async ({ data }: { data: CreateItemStatus }) =>
  await tempoApi().post('api/v1/item-store/item-statuses', { json: data }).json<ItemStatus>();

export const updateItemStatus = async ({
  itemStatusId,
  data,
}: {
  itemStatusId: number;
  data: UpdateItemStatus;
}) =>
  await tempoApi()
    .patch(`api/v1/item-store/item-statuses/${itemStatusId}`, { json: data })
    .json<ItemStatus>();

export const ItemStatusApi = {
  getItemStatusById,
  getItemStatuses,
  createItemStatus,
  updateItemStatus,
} as const;
